import React, { useMemo, useState } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import {
    deleteMeetingRecording,
    GetMeetingListItemData
} from "../../../../../../../service/meeting";
import { Popover, List, Icon } from "antd";
import PreviewFileModal from "../../../../../../../components/PreviewFileModal";
import AsideLink from "../../../../../Group/Components/AddGroupActivityModal/Components/StepThree/Components/AsideLink";
import _ from "underscore";
import { useToggle } from "react-use";
import DeleteConfirm from "../../../../../../../components/DeleteConfirm";
import { ResultMessage } from "../../../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../../../service/service";
import useRequestFn from "../../../../../../../utils/useRequestFn";

interface Props {
    item: GetMeetingListItemData;
    reload: () => void;
}
const Index = ({ item, reload }: Props) => {
    const [unBindMeeting, { loading: delLoading }] = useRequestFn(
        deleteMeetingRecording
    );

    async function onDelete(id: string) {
        try {
            await unBindMeeting({ id });
            await reload();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    const content = useMemo(() => {
        return (
            <List size="small" className={style.list}>
                {item.recordingList.map(item => (
                    <List.Item
                        key={item.id}
                        actions={[
                            <Icon
                                type="eye"
                                className={style.icon}
                                onClick={() => onPrev(item.id)}
                            />,
                            <DeleteConfirm
                                title={`确定删除吗？`}
                                content={`回放文件：${item.name}`}
                                onSuccess={() => {
                                    onDelete?.(item.id);
                                }}>
                                <Icon type="delete" className={style.icon} />
                            </DeleteConfirm>
                        ]}>
                        <List.Item.Meta title={item.name} />
                    </List.Item>
                ))}
            </List>
        );
    }, [item.recordingList, item.id]);

    //预览
    const [defaultIndex, setDefaultIndex] = useState(0);

    function onPrev(id?: string) {
        togglePrev();
        const index = _.findIndex(
            item.recordingList || [],
            item => item.id === id
        );

        if (index !== undefined && index !== -1) {
            setDefaultIndex(index);
        }
    }

    //预览弹窗
    const [prevShow, togglePrev] = useToggle(false);

    const PreviewList = useMemo(() => {
        return item.recordingList.map(item => {
            return {
                id: item.id,
                fileType: item.name?.split(".").pop(),
                viewUrl: item.fileKey,
                fileName: item.name
            };
        });
    }, [item.recordingList, item.id]);

    return (
        <div className={style.root}>
            {item.recordingList.length > 0 && (
                <Popover
                    title="回放列表"
                    placement="bottomLeft"
                    content={content}>
                    <span className={style.cur}>
                        [已关联 {item.recordingList.length} 个录屏]
                    </span>
                </Popover>
            )}
            <div className={classNames(style.info)}>会议时间：{item.time}</div>

            <PreviewFileModal
                visible={prevShow}
                onCancel={togglePrev}
                selectedIndex={defaultIndex}
                list={PreviewList || []}
                asideRender={PreviewList.map((item, index) => (
                    <AsideLink
                        key={item.id}
                        active={index === defaultIndex}
                        onClick={() => setDefaultIndex(index)}
                        item={item}
                    />
                ))}
            />
        </div>
    );
};

export default Index;
